import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { DeclareMethod } from '/imports/methods';
import { Doc, FileMeta } from '/imports/types';

export interface Notification extends Doc {
  title: string;
  body: string;
  image?: FileMeta;
  icon?: string;
  link?: string;
  meta?: any;
  accountId?: string;
  userId?: string;
  isRead?: boolean;
}
export type Model = Notification;

export const Notifications = new Mongo.Collection<Notification>('notifications');

export const markNotificationsRead = DeclareMethod<void, void>('markNotificationsRead');

Meteor.isServer && Meteor.startup(async () => {
  await Notifications.createIndexAsync({ userId: 1 }, { sparse: true });
  await Notifications.createIndexAsync({ accountId: 1 }, { sparse: true });
});

/**
 * Inserts a notification, stamping it with the current creation time.
 * @param notification - the notification to insert (without _id)
 */
export const notify = async (notification: Omit<Notification, '_id'>) => {
  await Notifications.insertAsync({createdAt: new Date(), ...notification});
};